/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Charterer_Representative_DetailInputs */



/**
* | output |
* | --- |
* | "Acting as the charterer's eyes and hands at the quayside or during an operation. We attend on their behalf for cargo operations, incidents and day-to-day mat..." |
*
* @param {Service_Charterer_Representative_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_charterer_representative_detail = /** @type {((inputs?: Service_Charterer_Representative_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Charterer_Representative_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在码头或作业现场充当租家的耳目和帮手。我们代表租家处理货物作业、事故和日常事务，及时通报情况并维护其利益。")
	return /** @type {LocalizedString} */ ("Acting as the charterer's eyes and hands at the quayside or during an operation. We attend on their behalf for cargo operations, incidents and day-to-day matters, keeping them informed and protecting their interests.")
});